export default {
  'user.profile.company': 'Empresa',
  'user.profile.position': 'Puesto',
  'user.profile.changePassword': 'Cambiar Contraseña',
  'user.profile.twoFactor': 'Habilitar Two-Factor',
  'user.profile.modifyView': 'Modificar Vista',
  'user.profile.currentPassword': 'Contraseña Actual',
  'user.profile.password': 'Nueva Contraseña',
  'user.profile.confirmPassword': 'Confirmar Contraseña',
  'user.profile.labelTwoFactor': '¿Autenticación Two-Factor Habilidata?',
  'user.profile.': ' ',

  'user.menu.logout': 'Cerrar sesión',
  'user.menu.options': 'Opciones',
  'user.menu.profile': 'Perfil',
  'user.menu.resetPassword': 'Cambiar contraseña',
  'user.menu.locales': 'Idiomas',
  'user.menu.environments': 'Entornos',
  'user.menu.companies': 'Empresas',

  'user.forgot.title': 'Olvidé mi contraseña',
  'user.forgot.sent': '¡Listo!',
  'user.forgot.description':
    'Ingresa tu correo electrónico y te enviaremos un mensaje para crear tu nueva contraseña',
  'user.forgot.sent.description':
    'Te hemos enviado un link a tu correo electrónico para que puedas crear una nueva contraseña.',

  'user.login.forgotPassword': 'Olvidé mi contraseña',
  'user.login.reset.hint':
    'Debe tener mínimo 8 caracteres, incluir mayúsculas y minúsculas, un número y un caracter especial "!#*$@%&?".',
  'user.login.reset.sent': 'Su nueva contraseña ha sido creada de manera exitosa.',
  'user.login.reset.title': 'Ingresa tu nueva contraseña',
  'user.login.reset.link.error.title': 'Error',
  'user.login.reset.link.error.description': 'El enlace para el cambio de contraseña no es válido.',

  'user.twoFactor.providers': 'Proveedores',
  'user.twoFactor.provider.email': 'Código de correo electrónico',
  'user.twoFactor.title': 'Enviar Código de Verificación',
  'user.twoFactor.description': 'Seleccione proveedor de autenticación Two-Factor',
  'user.twoFactor.code.title': 'Introduzca Código de Verificación',
  'user.twoFactor.alert.title': 'Listo!',
  'user.twoFactor.alert.description': 'Te hemos enviado un correo con el código de seguridad.',
  'user.twoFactor.error.send': 'Error al enviar el código de verificación. Inténtalo de nuevo.',
  'user.twoFactor.error.validate': 'Código de seguridad incorrecto. Inténtalo de nuevo.',

  'user.login.subtitle': 'Utiliza otro servicio para ingresar',
  'user.login.confirm.link.error.description': 'El enlace para confirmar su cuenta no es válido.',
  'user.login.banner.title': 'The future is now',
  'user.login.banner.description':
    'Gestiona, configura y optimiza tus procesos con nuestra herramienta.',
};
